





















// 插件引入
import {
  defineComponent,
  onMounted,
  reactive,
  toRefs,
} from '@vue/composition-api';
import pdf from 'vue-pdf';

import request from '@utils/request';

export default defineComponent({
  name: 'pdfPage',
  components: {
    pdf,
  },
  setup(props, { root }) {
    const { fileName } = root.$route.query;
    const state: any = reactive({
      // 总页数
      pageTotal: 0,
      // 当前页
      currentPage: 1,
      // 缩放比例
      pageScale: 0.5,
      // 遮罩
      boxLoading: true,
      pageChangeTimer: null,
      pdfUrl: '',
    });

    // 设置pdf预览区域容器的缩放尺寸
    const getPdfSize = () => {
      return {
        transform: `scale(${state.pageScale})`,
      };
    };

    const getPdfUrl = async () => {
      const res = await request('login', 'downLoadFileBase64', { fileName });
      const src = res;
      state.pdfUrl = pdf.createLoadingTask(
        `data:application/pdf;base64,${src}`,
      );
      state.pdfUrl.promise.then((pdf) => {
        state.pageTotal = pdf.numPages;
      });
    };

    onMounted(getPdfUrl);
    return {
      ...toRefs(state),
      getPdfSize,
    };
  },
});
